import { IMAGES } from "../../constants/contact";

const steps = [
  {
    n: "Passo I",
    title: "Invio Estratto Conto",
    text: "Fotografa l'ultima bolletta POS o invia il PDF via messaggio.",
    img: IMAGES.diagnosi1,
    alt: "Mani che esaminano un estratto conto con una penna",
    testid: "step-1",
  },
  {
    n: "Passo II",
    title: "Analisi Singole Voci",
    text: "Calcolo il costo effettivo reale su carte consumer, aziendali e internazionali.",
    img: IMAGES.diagnosi2,
    alt: "Scrivania con calcolatrice e verifica delle commissioni",
    testid: "step-2",
  },
  {
    n: "Passo III",
    title: "Piano Comparativo",
    text: "Ricevi un prospetto chiaro con il risparmio annuo stimato.",
    img: IMAGES.diagnosi3,
    alt: "Report di confronto commissioni su tablet",
    testid: "step-3",
  },
];

export function Metodo() {
  return (
    <section id="diagnosi" data-testid="metodo-section" className="py-24 px-6 max-w-6xl mx-auto">
      <div className="text-center max-w-2xl mx-auto mb-16">
        <span className="font-sans text-xs uppercase tracking-widest text-[#1B4D3E] font-bold">
          Protocollo Trasparente
        </span>
        <h2 className="text-3xl md:text-5xl font-normal text-[#1B4D3E] mt-2">
          Tre passi per smettere di pagare troppo.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {steps.map((s) => (
          <div key={s.n} data-testid={s.testid} className="border border-[#E3DFD7] bg-white p-8">
            <span className="font-sans text-xs text-[#736F67] tracking-widest uppercase block mb-4">{s.n}</span>
            <h3 className="text-2xl font-normal text-[#1B4D3E] mb-3">{s.title}</h3>
            <p className="font-sans text-sm text-[#5A564F] leading-relaxed mb-6">{s.text}</p>
            <div className="aspect-video relative overflow-hidden frame-drift">
              <img src={s.img} alt={s.alt} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
